module.exports = __webpack_public_path__ + "img/teamtip_dashboard_start_202526.4b78ef87.png";